import { StatusBar } from "expo-status-bar";
import { Text, View } from "react-native";
import { NavigationContainer } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import Home from "./screens/Home";
import XML from "./screens/XML";
import FirebaseScreen from "./screens/FirebaseScreen";
import { StateContext } from "./lib/context";
import Login from "./screens/Login";
import Historial from "./screens/Historial";
import Checkout from "./screens/Checkout";
import Store from "./screens/Store";
import Toast from "react-native-toast-message";
import HomeVendedor from "./screens/HomeVendedor";
import StoreAdmin from "./screens/StoreAdmin";
import justATest from "./screens/justATest";
import nuStore from "./screens/nuStore";
import OldHome from "./screens/OldHome";
import Orders from "./screens/Orders";
import Order from "./screens/Order";
import Imprimir from "./screens/Imprimir";
import ThankYou from "./screens/ThankYou";
import UserOrders from "./screens/UserOrders";
import UserOrdersOrders from "./screens/UserOrdersOrders";
import MyAccount from "./screens/MyAccount";
import AdminDashboard from "./screens/AdminDashboard";
import Viajantes from "./screens/Viajantes";
import AltaViajante from "./screens/AltaViajante";
import LoginViajantes from "./screens/LoginViajantes";
import SeleccionarCliente from "./screens/SeleccionarCliente";
import OrdersViajantes from "./screens/OrdersViajantes";
import Logout from "./screens/Logout";
import AdminClientLookup from "./screens/AdminClientLookup";
import AdminImageUpload from "./screens/AdminImageUpload";
import AdminOrders from "./screens/AdminOrders";

export default function App() {
  const Stack = createNativeStackNavigator();
  return (
    <StateContext>
      <NavigationContainer linking={{ enabled: false }}>
        <Stack.Navigator>
          {/* <Stack.Screen
            name="Test"
            component={justATest}
            options={{
              headerShown: false,
            }}
          /> */}
          {/* <Stack.Screen
            name="Gracias"
            component={ThankYou}
            options={{
              headerShown: false,
            }}
          /> */}

          {/* <Stack.Screen
            name="Logout"
            component={Logout}
            options={{
              headerShown: false,
            }}
          /> */}
          <Stack.Screen
            name="Login"
            component={Login}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Home"
            component={Home}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Viajantes"
            component={Viajantes}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="LoginViajantes"
            component={LoginViajantes}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="SeleccionarCliente"
            component={SeleccionarCliente}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="AltaViajante"
            component={AltaViajante}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="OrdersViajantes"
            component={OrdersViajantes}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Admin"
            component={AdminDashboard}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="AdminOrders"
            component={AdminOrders}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Account"
            component={MyAccount}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Imprimir"
            component={Imprimir}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Todos"
            component={UserOrders}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Single"
            component={UserOrdersOrders}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Gracias"
            component={ThankYou}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Orders"
            component={Orders}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Order"
            component={Order}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="OldHome"
            component={OldHome}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="nuStore"
            component={nuStore}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Vendedor"
            component={HomeVendedor}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Store"
            component={Store}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="StoreAdmin"
            component={StoreAdmin}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Historial"
            component={Historial}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Checkout"
            component={Checkout}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="AdminClientLookup"
            component={AdminClientLookup}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name="AdminImageUpload"
            component={AdminImageUpload}
            options={{ headerShown: false }}
          />
          <Stack.Screen name="XML" component={XML} />
          <Stack.Screen name="Firebase" component={FirebaseScreen} />

        </Stack.Navigator>
      </NavigationContainer>
      <Toast />
    </StateContext>
  );
}
